export function brandHubQueryKey(...parts: readonly unknown[]) {
  return ['brandHub', ...parts] as const;
}
